export const PRIMARY_COLOR = "#03a54f"
export const SECONDARY_COLOR = "#0E0E0E"

export const SUCCESS_COLOR = "#27AE60"
export const WARNING_COLOR = "#F2C94C"
export const ERROR_COLOR = "#F74343"

export const BLACK_COLOR = "#000000"
export const GREY_COLOR = "#ACACAC"
export const WHITE_COLOR = "#FFFFFF"